"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MSResponseApiSchema = exports.MSMetaDataSchema = exports.MSLinksSchema = exports.MSVesselSchema = void 0;
var zod_1 = require("zod");
exports.MSVesselSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    mmsi: zod_1.z.string().optional(),
    imo: zod_1.z.string().optional(),
    country_code: zod_1.z.string().length(2, 'ISO country code must be 2 characters long'),
    type: zod_1.z.string(),
    length: zod_1.z.number(),
    breadth: zod_1.z.number(),
    width: zod_1.z.number().optional(),
    draft: zod_1.z.number().optional(),
    gross_tonnage: zod_1.z.number().optional(),
    main_engines_propulsion_power: zod_1.z.number().optional(),
    engines_type: zod_1.z.string().optional(),
});
exports.MSLinksSchema = zod_1.z.object({
    first: zod_1.z.string().nullable(),
    last: zod_1.z.string().nullable(),
    prev: zod_1.z.string().nullable(),
    next: zod_1.z.string().nullable(),
});
exports.MSMetaDataSchema = zod_1.z.object({
    current_page: zod_1.z.number(),
    from: zod_1.z.number(),
    path: zod_1.z.string(),
    per_page: zod_1.z.string(),
    to: zod_1.z.number(),
});
exports.MSResponseApiSchema = zod_1.z.object({
    data: zod_1.z.array(exports.MSVesselSchema),
    links: exports.MSLinksSchema,
    meta: exports.MSMetaDataSchema,
});
//# sourceMappingURL=ModernSea.js.map